<!--
 * @Author: Merlin
 * @Date: 2023-12-19 10:36:47
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-07 11:35:27
 * @Description: 
-->

<template>
    <NuxtLayout name="game-coat"
        :topHeight="'500px'"
    >
        <template #panel-left>
            hello left 
        </template>
        <!-- 
            分界 
        -->
        <template #playing-area-right
            v-if="testValue"
        >
            hello right 
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">

const testValue = ref(true);


</script>
<style scoped lang="scss">

</style>



